<template>
    <div class="animated fadeIn">        
        <b-card>
            <div slot="header">
                Progress Internal Budget
                <div class="card-header-actions">
                <button class="btn btn-primary mr-1" @click="print()"><i class="fa fa-print"></i> Print</button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
              <b-row>
                <b-col lg="8">
                    <b-row>
                        <b-col md="6">
                            <b-input-group>
                                <b-input-group-prepend><label>Internal Budget No.</label></b-input-group-prepend>
                                <b-form-input v-model="model.nomorintern" readonly ></b-form-input>
                                <b-input-group-append>
                                <b-btn text="Button" @click="lkuBudgetShow=true" >
                                    <i class="fa fa-search"></i>
                                </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                        <b-col md="4">                            
                            <b-input-group>
                                <b-input-group-prepend><label>Create Date</label></b-input-group-prepend>
                                <b-form-input v-model="model.ibtanggal" type="date"  disabled></b-form-input>                                        
                            </b-input-group>
                        </b-col>
                    </b-row >  
                    <b-row>
                        <b-col md="9">
                            <b-input-group >
                                <b-input-group-prepend><label>Budget Name</label></b-input-group-prepend>
                                <b-form-input v-model="model.uraian"  readonly></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col md="3">
                            <b-form-checkbox :value="1" :unchecked-value="0" v-model="model.sales" disabled class="mt-1">Budget Sales/Project</b-form-checkbox>
                        </b-col>
                    </b-row>    

                    <b-row>
                        <b-col md="6">                            
                            <b-input-group>
                                <b-input-group-prepend><label>Nomor Produksi.</label></b-input-group-prepend>
                                <b-form-input v-model="model.noprodintern" readonly placeholder="comma separated" ></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col md="6">
                            <b-input-group >
                                    <b-input-group-prepend><label >Tanggal Produksi</label></b-input-group-prepend>
                                    <b-form-input v-model="model.requstart" type="date" disabled></b-form-input>
                                    <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                                    <b-form-input v-model="model.requend" type="date" disabled></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-row >  
                    <b-row v-if="(model.sales=='1')">
                        <b-col md="7">
                            <b-input-group >
                                <b-input-group-prepend><label>Customer</label></b-input-group-prepend>
                                <b-form-input readonly v-model="model.custinfo" ></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col md="5">
                            <b-input-group >
                                <b-input-group-prepend><label>Customer Order No.</label></b-input-group-prepend>
                                <b-form-input v-model="model.cust_po" placeholder="Customer Order No." readonly></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-row>    
                </b-col>
                <b-col md="4">
                    <v-dim :model="model" :key="updateDimHdr"></v-dim>
                </b-col>
              </b-row>
              <b-card no-body class="mb-1">
                <div class="report-wraper">
                    <table width="100%">
                        <thead>
                           <tr>
                            <th rowspan="2" style="max-width:20px; text-align:center; padding-left:2px; padding-right:2px;">No</th>
                            <th style="min-width:500px" rowspan="2">Description</th>
                            <th style="text-align:center; max-width:100px;" rowspan="2">Unit</th>
                            <th style="text-align:center; max-width:70px;" rowspan="2">QTY</th>
                            <th style="text-align:center; max-width:70px;" rowspan="2">Repe-tition</th>
                            <th width="100px" style="text-align:center;" rowspan="2">BUDGET</th>
                            <th width="100px" style="text-align:center;" rowspan="2">REQUESTED</th>
                            <th width="100px" style="text-align:center;" rowspan="2">BALANCE</th>
                <th colspan="6" style="text-align: center">
                  DETAIL REQUESTED/USAGE
                </th>
              </tr>
              <tr>
                <th width="100px" style="text-align: center">PO/SO</th>
                <th width="100px" style="text-align: center">AP INVOICE</th>
                <th width="100px" style="text-align: center">INVENTORY</th>
                <th width="100px" style="text-align: center">ADVANCE</th>
                <th width="100px" style="text-align: center">ADV STTL</th>
                <th width="100px" style="text-align: center">EXPENSE</th>
              </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, idx) in budgetLines" :key="row.pjxbudgkey" @click="lineDetail(row)">
                            <td style="max-width:20px; padding-left:2px; padding-right:0;">{{idx+1}}</td>
                             <td>{{row.jccostname}} &nbsp; &nbsp; {{row.uraian}}</td>
                             <td>{{row.unitsize}}</td>
                             <td>{{row.ibquantity |numFormat}}</td>
                             <td><span v-if="(row.ibrepetit_qty)">{{row.ibrepetit_qty}} <span v-if="(row.repetit_nm)">| {{row.repetit_nm}}</span></span></td>
                             <td style="text-align:right;">{{row.ibbudgetamt |numFormat}}</td>
                             <td style="text-align:right;"><b-link @click="lineDetail(row,'')">{{row.totalreq |numFormat}}</b-link></td>
                             <td style="text-align:right;">{{row.ibbudgetost |numFormat}}</td>
                             <td style="text-align:right;"><b-link @click="lineDetail(row,'Purchase Order')">{{(row.pottl) |numFormat}}</b-link></td>
                             <td style="text-align:right;"><b-link @click="lineDetail(row,'AP Invoice')">{{(row.apttl) |numFormat}}</b-link></td>
                             <td style="text-align:right;"><b-link @click="lineDetail(row,'Inventory Issued')">{{(row.invttl) |numFormat}}</b-link></td>
                             <td style="text-align:right;"><b-link @click="lineDetail(row,'Advance Request')">{{row.cattl |numFormat}}</b-link></td>
                             <td style="text-align:right;"><b-link @click="lineDetail(row,'Advance Settlement')">{{row.capjttl |numFormat}}</b-link></td>
                             <td style="text-align:right;"><b-link @click="lineDetail(row,'Expense Reimburs')">{{row.ecttl |numFormat}}</b-link></td>
                            </tr>
                            <tr>
                             <td class="subtotal"></td>
                             <td colspan="4" class="subtotal" style="text-align:right;">Total </td>
                             <td class="grdtotal" style="text-align:right;">{{model.budgettotal | numFormat}}</td>
                             <td class="grdtotal" style="text-align:right;">{{model.usedtotal | numFormat}}</td>
                             <td class="grdtotal" style="text-align:right;">{{model.osttotal | numFormat}}</td>
                             <td class="grdtotal" style="text-align:right;">{{model.pototal | numFormat}}</td>
                             <td class="grdtotal" style="text-align:right;">{{model.apinvttl | numFormat}}</td>
                             <td class="grdtotal" style="text-align:right;">{{model.invtotal | numFormat}}</td>
                             <td class="grdtotal" style="text-align:right;">{{model.catotal | numFormat}}</td>
                             <td class="grdtotal" style="text-align:right;">{{model.capjtotal | numFormat}}</td>
                             <td class="grdtotal" style="text-align:right;">{{model.ectotal | numFormat}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

              </b-card>    
        </b-card>
        <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
        <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
            <iframe :src="reportUrl" frameborder="0"></iframe>
        </b-modal>
        <b-modal v-model="showDetail" size="xl" title="Budget Usage Detail" header-bg-variant="primary"  ok-only>
            <b-card no-body>
                <template v-slot:header >    
                    <b-row>
                        <b-col md="12" >
                            <b-input-group>
                                <b-input-group-prepend><label>Costing Item</label></b-input-group-prepend>
                                <b-form-input readonly v-model="record.jccostname" style="width:35% !important;"></b-form-input>
                                <b-input-group-prepend><span class="p-2">Amount</span></b-input-group-prepend>
                                <b-input-group-prepend>
                                <span class="input-group-text">{{uanguser}}</span>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" v-model="record.ibbudgetamt" :precision="2" disabled></my-number>
                                <b-form-checkbox v-model="record.noncash" :value="1" :unchecked-value="0"  class="pt-2">Non CASH</b-form-checkbox>
                            </b-input-group>
                        </b-col>
                    </b-row>         
                    <b-row >
                        <b-col md="12">
                            <b-input-group>
                                <b-input-group-prepend><label>Note/Remark</label></b-input-group-prepend>
                                <b-form-textarea :rows="2" :max-rows="5" v-model="record.uraian" readonly></b-form-textarea>
                            </b-input-group>
                        </b-col>
                    </b-row>          
                </template>

            <b-table
            class="mb-0"
            ref="tblLineDetail"
            responsive
            striped hover
            style="font-size:smaller;" 
            :items="lineDetails"
            :fields="lineFields"
            :filter="filter"
            @filtered="onFiltered"                
            >
                <template v-slot:cell(index)="data">
                {{ data.index +1}}
                </template>
                <template v-slot:cell(doc_date)="data">
                {{ data.item.doc_date | moment("DD MMM YYYY")}}
                </template>
                <template v-slot:cell(nilaidue)="data">
                {{ data.item.nilaidue | numFormat}}
                </template>
            </b-table>
                    <b-row class="mt-1">
                        <b-col lg="7">
                            <b-input-group >
                                <b-input-group-prepend><label >Filter Trx.Source</label></b-input-group-prepend>
                                <b-form-select :options="['Inventory Issued','Purchase Order','Account Payable','Advance Request','Advance Settlement','Expense Reimburs']" 
                                    :plain="true" v-model="filter"  />
                                <b-input-group-append>
                                    <b-button :disabled="!filter" @click="clearFilter">Clear</b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col> 
                        <b-col lg="5">
                            <b-input-group>
                                <b-input-group-prepend><span class="p-2">Total {{filter}} :</span></b-input-group-prepend>
                                <my-number class="form-control text-right" v-model="lineTotalval" :precision="2" disabled></my-number>
                            </b-input-group>
                        </b-col> 
                    </b-row>
            </b-card>
        </b-modal>
        <b-modal v-model="lkuBudgetShow" size="lg" :hide-footer="true" title="List of Internal Budget" :centered="true">
            <lku-budgetinternal @click="onSelectLkuBudget"></lku-budgetinternal>
        </b-modal>        
    </div>
</template>
<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
 </style>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import moment from 'moment';
import lkuBudgetinternal from "../lookup/lkuBudgetinternal";
import myNumber from "../../components/my-number";
import vDim from "../lookup/dimReadonly";
import budgetinternal from "../../apis/budgetinternal";
toastr.init();

export default {   
  components: { Loading, lkuBudgetinternal, vDim,myNumber},
  data() {
    return {
        lkuBudgetShow:false,
        saveEnabled:true,
        updateDimHdr:false,
        uanguser: this.$store.state.user.matauang,
        model:{sales:0, Dim1:'', jmlproduksi:1, nomorproduksi:'',cust_po:'',cust_id:''},
      isLoading: false,
      reportUrl: null,
      showReport:false,
      budgetLines:[], 
      showDetail:false,
      record:{ibbudgetamt:0},
      filter:'',
      filterOn:['asaltrx'],
      lineDetails:[],
      lineFields:[
          {
            key: "index",
            thStyle: "width:50px",
            label: "No.",
            thClass: "text-center",
            tdClass: "text-center",
          },
          {
            key: "doc_date",
            label: "Trx.Date",
          },
          {
            key: "asaltrx",
            label: "Trx.Source",
          },
          {
            key: "doc_no",
            label: "Trx.Number",
          },
          {
            key: "vendorinfo",
            label: "Employee/Vendor",
          },
          {
            key: "remark",
            label: "Trx. Description",
          },
          {
            key: "nilaidue",
            thStyle: "width:100px",
            label: "Trx.Value",
            thClass: "text-center",
            tdClass: "text-center",
          },
          {
            key: "createby",
            label: "Input By",
          },

      ],
      lineTotalval:0,
    };
},
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
  },
  watch: {
    dimension: function(newArr) {
        newArr.forEach((dim) => {
                    if (this.model[dim.value]) {
                        this.model[`${dim.value}Info`] = this.model[dim.value] + ' | '+ this.model[`${dim.value}Txt`];
                    }
                });               
        this.updateDimHdr = !this.updateDimHdr;
    }    
  },
  created: async function(){
        if (this.$route.params.ibudghdkey)  {
            this.getProgress(this.$route.params.ibudghdkey);
        }
  },
  methods: {
     onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.lineTotalval=filteredItems.reduce((a, b) => a + b.nilaidue, 0);
    },
    clearFilter() {
      this.filterOn= []   
      this.filter= '';   
    },
    lineDetail: async function(record, asaltrx)
    {
        toastr.success(`Loading Budget Usage Detail "${record.jccostname}", please wait`)
            this.isLoading=true;
            try {
                this.lineTotalval=0;
                this.filter=asaltrx || '';
                this.record=record;
                this.lineDetails= await budgetinternal.progressdtl(record);
                this.showDetail=true;
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                console.log('error : ', error);
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }   
            }

    },
    print: async function()
    {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            try {
                this.showReport=true;
                this.reportUrl= await budgetinternal.progressprint(this.model);
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },    
    getProgress: async function (ibudghdkey) {
          toastr.info('Loading Budget Progress, please wait');
        try {
            this.isLoading=true;         
            const data = await budgetinternal.progress({ibudghdkey});  
            const row = data[1][0];
            row.tanggal = row.tanggal ? moment(row.tanggal).format('YYYY-MM-DD') : '';
            row.startdate = row.startdate ? moment(row.startdate).format('YYYY-MM-DD') : '';
            row.finishdate = row.finishdate ? moment(row.finishdate).format('YYYY-MM-DD') : '';
            for (var key in row) {
                this.model[key] = row[key];
            }
            this.dimension.forEach((dim) => {
                if (row[dim.value]) {
                    this.model[`${dim.value}Info`] = row[dim.value] + ' | '+ row[`${dim.value}Txt`];
                }
            });
            this.updateDimHdr=!this.updateDimHdr;
            this.budgetLines = data[0];
            // this.budgetLines.forEach((line,idx) => {
            //     this.budgetLines[idx].budgetrata2=line.budgetamt/this.model.jmlproduksi;
            //     this.budgetLines[idx].addquantity=0;
            //     this.budgetLines[idx].addrepetit_qty='';
            // });

            // this.calcTotalDtlBudget();
            this.isLoading=false;
          } catch (error) {
                this.isLoading=false;
                console.log('error : ', error);
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }   
          }

    },
    onSelectLkuBudget: async function (_selected) {
        this.lkuBudgetShow=false;
        this.getProgress(_selected.ibudghdkey);

    },
    // calcTotalDtlBudget() {
    //     let ttlBudget = 0;
    //     let ttlUsed = 0;
    //     let ttlPo = 0;
    //     let ttlCa = 0;
    //     let ttlEc = 0;
    //     this.budgetLines.forEach((trx)=> {
    //             ttlBudget += (trx.budgetamt || 0);
    //             ttlUsed += (trx.totalreq || 0);
    //             ttlPo += ((trx.pottl || 0) +(trx.sottl || 0));
    //             ttlCa += (trx.cattl || 0);
    //             ttlEc += (trx.ecttl || 0);
    //             trx.budgetost= trx.budgetamt-trx.totalreq;
    //     });
    //     this.model.budgettotal = ttlBudget;
    //     this.model.usedtotal = ttlUsed;
    //     this.model.osttotal = ttlBudget-ttlUsed;
    //     this.model.pototal = ttlPo;
    //     this.model.catotal = ttlCa;
    //     this.model.ectotal = ttlEc;
    // },
    close(){
    //   console.log('this.$store.state.prevRoute.name : ',this.$store.state.prevRoute.name);
      if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'budget.mstrbudgetprogress')) {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
        // router.push({name:'payable.apinv'});
          router.push("home");
      }
    }
  }
};
</script>
